import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import AssetMapDetail from "@/components/AssetMapDetail";
import Marquee from "@/components/Marquee";
import { eamApi } from "@/api/eamApi";
import { uamApi } from "@/api/uamApi";
import { lcgApi } from "@/api/lcgApi";
const AssetMap3D = ({ className = "", type = "eam", fontSize = 16, jsonUrl = "", floorInfo = {} }) => {
    const childRef = useRef(null);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedAssetDetail, setSelectedAssetDetail] = useState(null);
    const [assetTitle, setAssetTitle] = useState('');
    const [cameraLock, setCameraLock] = useState(false);
    let api = { eam: eamApi, uam: uamApi, lcg: lcgApi }[type];
    const floorData = useRef({});
    const onBuildingEnter = (name, id) => {
        setAssetTitle(name);
    };
    const onBuildingLeave = (name, id) => {
        setAssetTitle('');
    };
    const onBuildingClick = async (name, pointId) => {
        setSelectedAsset(null);
        let pointName = name.replace('\n', '');
        setAssetTitle(pointName);
        let res = await api.getLocation({ locationCode: pointId });
        let data = res.data || {};
        if (!data)
            return false;
        let { usingLocation, count, pcount, assetList = [] } = data;
        setSelectedAsset(Object.assign(floorData.current, {
            pointId, pointName,
            description: usingLocation,
            count,
            detail: assetList.length ? {
                label: '资产详情单',
                list: assetList.map((item) => {
                    return {
                        id: item.assetId,
                        name: item.assetCode,
                        value: item.assetName,
                        spec: item.spec
                    };
                })
            } : null
        }));
    };
    const onCameraFocus = () => {
        setCameraLock(true);
    };
    const onCameraBlur = () => {
        setSelectedAsset(null);
        setCameraLock(false);
        setAssetTitle('');
    };
    const onPointClick = (pointInfo) => {
        let { pointId, pointName } = pointInfo;
        setSelectedAsset(null);
        setTimeout(() => onBuildingClick(pointName, pointId));
    };
    const handlePointDetail = (data) => {
        console.log(data);
    };
    const onLoad = async () => {
        setSelectedAssetDetail(null);
        setSelectedAsset(null);
        let { name, pointId, pointName } = floorInfo;
        let res = await api.getLocation({ locationCode: pointId });
        let data = res.data || {};
        if (!data)
            return false;
        let { pusingLocation, count, assetList = [] } = data;
        floorData.current = {
            name: name + pointName,
            pcount: count,
            detail: assetList.length ? {
                label: '资产详情单',
                list: assetList.map((item) => {
                    return {
                        id: item.assetId,
                        name: item.assetCode,
                        value: item.assetName,
                        spec: item.spec
                    };
                })
            } : null
        };
        setSelectedAsset(floorData.current);
    };
    return (_jsxs("div", { style: { width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }, children: [_jsx(AssetMapDetail, { ref: childRef, className: "h-full", jsonUrl: jsonUrl, fontSize: fontSize, onBuildingEnter: onBuildingEnter, onBuildingLeave: onBuildingLeave, onBuildingClick: onBuildingClick, onCameraFocus: onCameraFocus, onCameraBlur: onCameraBlur, onPointClick: onPointClick, onLoad: onLoad }), cameraLock && (_jsx("div", { className: "absolute top-1 left-1", children: _jsx(Button, { style: { background: '#fff', color: '#000' }, onClick: () => { childRef?.current?.cameraBlur?.(); }, size: "large", color: "default", variant: "solid", shape: "circle", icon: _jsx(ArrowLeftOutlined, {}) }) })), selectedAsset && (_jsx("div", { className: "absolute z-20 p-1 text-white border top-1 right-2 bg-gray-900/38 border-gray-600/0 min-w-12", style: { animation: 'fadeInRight 1s both', borderRadius: '.2rem' }, children: _jsxs("div", { className: "text-xs", style: { fontSize: `${fontSize / 100}rem`, lineHeight: 1.5 }, children: [_jsxs("div", { className: "flex", style: { marginBottom: 5 }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon01.png", style: { width: '.2rem', height: '.21rem', marginRight: '.1rem' } }), "\u697C\u5C42\uFF1A"] }), _jsx("span", {})] }), _jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u5EFA\u7B51\u540D\u79F0\uFF1A" }), _jsx("span", { children: selectedAsset.name })] }), _jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u7269\u8D44\u603B\u6570\uFF1A" }), _jsxs("span", { children: [selectedAsset.pcount || 0, "\u4E2A"] })] }), selectedAsset.pointName && (_jsxs("div", { className: "flex", style: { margin: '.05rem 0' }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon01.png", style: { width: '.2rem', height: '.21rem', marginRight: '.1rem' } }), "\u623F\u95F4\uFF1A"] }), _jsx("span", {})] })), selectedAsset.pointName && (_jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u623F\u95F4\u540D\u79F0\uFF1A" }), _jsx("span", { children: selectedAsset.pointName })] })), selectedAsset.description && selectedAsset.description !== selectedAsset.pointName && (_jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u623F\u95F4\u63CF\u8FF0\uFF1A" }), _jsx("span", { children: selectedAsset.description })] })), selectedAsset.pointName && (_jsxs("div", { className: "flex", children: [_jsx("span", { className: "text-gray-300", children: "\u7269\u8D44\u603B\u6570\uFF1A" }), _jsxs("span", { children: [selectedAsset.count || 0, "\u4E2A"] })] })), selectedAsset.detail && (_jsxs("div", { className: "flex", style: { margin: '.05rem 0' }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon02.png", style: { width: '.12rem', height: '.12rem', marginRight: '.1rem' } }), selectedAsset.detail.label, "\uFF1A"] }), _jsx("span", {})] })), selectedAsset.detail && _jsx(Marquee, { animate: selectedAsset.detail.list.length > 8, duration: selectedAsset.detail.list.length * 1.25, children: selectedAsset.detail.list.map((d, i) => {
                                return (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: d.name ? d.name + ':' : '' }), _jsx("span", { children: d.value })] }, i));
                            }) })] }) })), assetTitle && (_jsx("div", { className: "absolute z-20 text-white transform -translate-x-1/2 border top-1 left-1/2 bg-gray-900/38 border-gray-600/0 min-w-1", style: { padding: '.1rem .2rem', borderRadius: '.1rem' }, children: _jsx("div", { style: { fontSize: `${fontSize / 100}rem` }, children: assetTitle }) }))] }));
};
export default AssetMap3D;
